// Vertical A–Z quick-jump rail. Tapping a letter tells the parent to load
// records starting at that letter (server-side prefix filter + name sort).
const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function AlphaRail({ active, onPick, testId = "alpha-rail" }) {
  return (
    <div className="fixed right-1 top-16 bottom-24 z-[80] hidden md:flex items-center pointer-events-none">
      <div
        data-testid={testId}
        className="flex flex-col items-center gap-[1px] py-2 px-0.5 max-h-full overflow-y-auto pointer-events-auto rounded-full border border-white/10 bg-[#0B1120]/85 backdrop-blur-md shadow-[0_8px_30px_rgba(0,0,0,0.5)]"
      >
      <button
        type="button"
        onClick={() => onPick(null)}
        data-testid={`${testId}-all`}
        className={`text-[9px] font-mono leading-none px-1 py-0.5 rounded transition ${
          !active ? "text-white bg-white/10" : "text-slate-500 hover:text-white"
        }`}
        title="Show all"
      >
        •
      </button>
      {LETTERS.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => onPick(l)}
          data-testid={`${testId}-${l}`}
          className={`text-[10px] leading-none w-4 h-[15px] grid place-items-center rounded transition ${
            active === l ? "text-white bg-orange-500/40 font-bold" : "text-slate-400 hover:text-white hover:bg-white/10"
          }`}
        >
          {l}
        </button>
      ))}
      </div>
    </div>
  );
}
